import { render, staticRenderFns } from "./VGTCLogo.vue?vue&type=template&id=a1af0d54"
import script from "./VGTCLogo.vue?vue&type=script&lang=ts"
export * from "./VGTCLogo.vue?vue&type=script&lang=ts"
import style0 from "./VGTCLogo.vue?vue&type=style&index=0&id=a1af0d54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports